module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "page-wrapper"
  }, [_c('section', {
    attrs: {
      "id": "container"
    }
  }, [_c('component-header'), _vm._v(" "), _c('section', {
    attrs: {
      "id": "main-content"
    }
  }, [_c('section', {
    staticClass: "wrapper"
  }, [_c('div', {
    staticClass: "market-updates"
  }, [_c('div', {
    staticClass: "col-md-3 market-update-gd"
  }, [_c('a', {
    staticStyle: {
      "color": "inherit"
    },
    attrs: {
      "href": "users"
    }
  }, [_c('div', {
    staticClass: "market-update-block clr-block-2"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "col-md-8 market-update-left"
  }, [_c('h4', [_vm._v("Users")]), _vm._v(" "), (_vm.users) ? _c('h3', [_vm._v(_vm._s(_vm.users.length))]) : _vm._e(), _vm._v(" "), _c('p', [_vm._v("@ count Today")])]), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 market-update-gd"
  }, [_c('a', {
    staticStyle: {
      "color": "inherit"
    },
    attrs: {
      "href": "businesses"
    }
  }, [_c('div', {
    staticClass: "market-update-block clr-block-1"
  }, [_vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "col-md-8 market-update-left"
  }, [_c('h4', [_vm._v("Businesses")]), _vm._v(" "), (_vm.businesses) ? _c('h3', [_vm._v(_vm._s(_vm.businesses.length))]) : _vm._e(), _vm._v(" "), _c('p', [_vm._v("@ count Today")])]), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 market-update-gd"
  }, [_c('a', {
    staticStyle: {
      "color": "inherit"
    },
    attrs: {
      "href": "cnpros"
    }
  }, [_c('div', {
    staticClass: "market-update-block clr-block-3"
  }, [_vm._m(2), _vm._v(" "), _c('div', {
    staticClass: "col-md-8 market-update-left"
  }, [_c('h4', [_vm._v("CNpros")]), _vm._v(" "), (_vm.cnpros) ? _c('h3', [_vm._v(_vm._s(_vm.cnpros.length))]) : _vm._e(), _vm._v(" "), _c('p', [_vm._v("@ count Today")])]), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 market-update-gd"
  }, [_c('a', {
    staticStyle: {
      "color": "inherit"
    },
    attrs: {
      "href": "forums"
    }
  }, [_c('div', {
    staticClass: "market-update-block clr-block-4"
  }, [_vm._m(3), _vm._v(" "), _c('div', {
    staticClass: "col-md-8 market-update-left"
  }, [_c('h4', [_vm._v("Forums")]), _vm._v(" "), (_vm.forums) ? _c('h3', [_vm._v(_vm._s(_vm.forums.length))]) : _vm._e(), _vm._v(" "), _c('p', [_vm._v("@ count Today")])]), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  })]), _vm._v(" "), _vm._m(4), _vm._v(" "), _c('div', {
    staticClass: "agil-info-calendar"
  }, [_c('div', {
    staticClass: "col-md-12 w3agile-notifications"
  }, [_c('div', {
    staticClass: "notifications"
  }, [_c('header', {
    staticClass: "panel-heading"
  }, [_vm._v("\r\n                                Real Time Activities\r\n                            ")]), _vm._v(" "), _c('div', {
    staticClass: "notify-w3ls"
  }, _vm._l((_vm.activities), function(act) {
    return _c('div', [_c('div', {
      class: 'alert ' + act.activity_info_type + ' clearfix'
    }, [_c('span', {
      staticClass: "alert-icon"
    }, [_c('i', {
      class: act.activity_info_icon
    })]), _vm._v(" "), _c('div', {
      staticClass: "notification-info"
    }, [_c('ul', {
      staticClass: "clearfix notification-meta"
    }, [_c('li', {
      staticClass: "pull-left notification-sender"
    }, [_vm._v(_vm._s(act.activity_subject))]), _vm._v(" "), _c('li', {
      staticClass: "pull-right notification-time"
    }, [_vm._v(_vm._s(act.activity_date))])]), _vm._v(" "), _c('p', [_vm._v("\r\n                                                    " + _vm._s(act.activity_snippet) + "\r\n                                            ")])])])])
  }))])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6 w3agile-notifications"
  }), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  })])]), _vm._v(" "), _c('component-footer')], 1)], 1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-md-4 market-update-right"
  }, [_c('i', {
    staticClass: "fa fa-users"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-md-4 market-update-right"
  }, [_c('i', {
    staticClass: "fa fa-briefcase"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-md-4 market-update-right"
  }, [_c('i', {
    staticClass: "fa fa-crosshairs"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-md-4 market-update-right"
  }, [_c('i', {
    staticClass: "fa fa-meh-o",
    attrs: {
      "aria-hidden": "true"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "panel-body"
  }, [_c('div', {
    staticClass: "col-md-12 w3ls-graph"
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-f4980b9c"}!./src/components/Dashboard/template.html
// module id = 175
// module chunks = 0